import { ListAgenticLogicTemplatesResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const listAgenticLogicTemplates = async () => {
  const response = await api.get<ListAgenticLogicTemplatesResponseBodyType>(
    "/v2/agentic-logic/templates"
  );
  return response.data;
};

export const useAgenticLogicTemplates = () =>
  useQuery<ListAgenticLogicTemplatesResponseBodyType, Error>({
    queryKey: agenticLogicKeys.templates(),
    queryFn: listAgenticLogicTemplates,
    staleTime: Number.POSITIVE_INFINITY,
  });
